import React from 'react';
import Masonry from 'react-masonry-css'

const NewsMasonry = (props) => {

    const { items } = props;

    const breakpointColumnsObj = {
        default: 4,
        1100: 3,
        750: 2,
        500: 1
    };

    const childElements = items.map(function (item) {
        return (
            <div className="news__items--masonry" key={item.Title}>
                <div className='news__items--masonry-image'>
                <a href={item.Url}><img alt="" src={item.ImageUrl} /></a>
                <div className='news__items--masonry-tag'>
                {item.CategoryTag}
                </div>
                </div>
                <div className='news__items--masonry-title'>
                {item.Title}
                </div>
                <div className='news__items--masonry-text'>
                {item.Text}
                </div>
            </div>
        );
    });

    return (
        <div className="masonry-wrapper">
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="news__component--masonry"
                columnClassName="news__component--masonry_column">
                {childElements}
            </Masonry>
        </div>
    );
}

export default NewsMasonry;